module.exports = __webpack_public_path__ + "img/bio_thawer_offline.55e87a4d.png";